"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ArtBlocksClient: () => ArtBlocksClient,
  SubmissionStatusEnum: () => SubmissionStatusEnum
});
module.exports = __toCommonJS(src_exports);

// src/types.ts
var SubmissionStatusEnum = {
  SIMULATING_TRANSACTION: "SIMULATING_TRANSACTION",
  AWAITING_USER_SIGNATURE: "AWAITING_USER_SIGNATURE",
  CONFIRMING: "CONFIRMING",
  SYNCING: "SYNCING"
};

// src/minter-configuration/index.ts
var import_get6 = __toESM(require("lodash/get"));

// src/utils/process-form-schema.ts
function orderJsonSchema(schema) {
  if (schema.type !== "object" || !schema.properties) {
    return schema;
  }
  let orderedProperties = {};
  if (schema["ui:order"]) {
    schema["ui:order"].forEach((field) => {
      if (schema.properties && schema.properties[field] && schema.properties[field] !== false) {
        orderedProperties[field] = orderJsonSchema(
          schema.properties[field]
        );
      }
    });
    for (const field in schema.properties) {
      if (!orderedProperties[field] && schema.properties[field] !== false) {
        orderedProperties[field] = orderJsonSchema(
          schema.properties[field]
        );
      }
    }
  } else {
    orderedProperties = Object.keys(schema.properties).reduce(
      (acc, field) => {
        if (schema.properties && schema.properties[field] && schema.properties[field] !== false) {
          acc[field] = orderJsonSchema(
            schema.properties[field]
          );
        }
        return acc;
      },
      {}
    );
  }
  return __spreadProps(__spreadValues({}, schema), {
    properties: orderedProperties
  });
}
function processFormSchema(schema) {
  const properties = schema.properties ? ((_a) => {
    var _b = _a, { projectIndex, coreContractAddress } = _b, rest = __objRest(_b, ["projectIndex", "coreContractAddress"]);
    return rest;
  })(
    schema.properties
  ) : void 0;
  const required = schema.required ? schema.required.filter(
    (item) => item !== "projectIndex" && item !== "coreContractAddress"
  ) : void 0;
  const orderedSchema = orderJsonSchema(__spreadProps(__spreadValues({}, schema), {
    properties,
    required
  }));
  return orderedSchema;
}

// src/utils/zod.ts
var import_zod = require("zod");

// src/json-schema.ts
var ValidationConditionEnum = {
  /** The value of the field must be greater than a specified value. */
  GREATER_THAN: "greaterThan",
  /** The value of the field must be less than a specified value. */
  LESS_THAN: "lessThan",
  /** The value of the field must be greater than or equal to a specified value. */
  GREATER_THAN_OR_EQUAL: "greaterThanOrEqual",
  /** The value of the field must be less than or equal to a specified value. */
  LESS_THAN_OR_EQUAL: "lessThanOrEqual",
  /** The value of the field must be equal to a specified value. */
  EQUAL: "equal"
};
function isTopLevelFormField(property) {
  return (property == null ? void 0 : property.onChain) !== void 0;
}
function isOnChainFormFieldSchema(property) {
  return isTopLevelFormField(property) && property.onChain;
}

// src/utils/zod.ts
var import_get = __toESM(require("lodash/get"));
function formFieldSchemaToZod(formFieldSchema) {
  function createNestedZodSchema(properties, parentSchema) {
    const zodSchema2 = {};
    for (const [key, prop] of Object.entries(properties)) {
      if (prop && typeof prop === "object") {
        const nestedKeys = key.split(".");
        let currentSchema = zodSchema2;
        for (let i = 0; i < nestedKeys.length; i++) {
          const currentKey = nestedKeys[i];
          const isLastKey = i === nestedKeys.length - 1;
          if (isLastKey) {
            currentSchema[currentKey] = toZod(prop, key, parentSchema);
          } else {
            if (!currentSchema[currentKey]) {
              currentSchema[currentKey] = import_zod.z.object({});
            }
            currentSchema = currentSchema[currentKey].shape;
          }
        }
      }
    }
    return import_zod.z.object(zodSchema2);
  }
  function toZod(prop, fullKey, parentSchema) {
    let zodProp;
    if ("ui:widget" in prop && prop["ui:widget"] === "file") {
      return import_zod.z.any();
    }
    if (prop.readOnly) {
      return import_zod.z.any();
    }
    switch (prop.type) {
      case "number":
      case "integer": {
        if (prop.type === "integer") {
          zodProp = import_zod.z.union([import_zod.z.string(), import_zod.z.number()]).superRefine((val, ctx) => {
            try {
              const transformedVal = typeof val === "string" ? BigInt(val) : val;
              if (prop.minimum != null && transformedVal < prop.minimum) {
                ctx.addIssue({
                  code: import_zod.z.ZodIssueCode.too_small,
                  minimum: prop.minimum,
                  type: "number",
                  inclusive: true,
                  message: "Value is too small"
                });
              }
              if (prop.maximum != null && transformedVal > prop.maximum) {
                ctx.addIssue({
                  code: import_zod.z.ZodIssueCode.too_big,
                  maximum: prop.maximum,
                  type: "number",
                  inclusive: true,
                  message: "Value is too big"
                });
              }
            } catch (e) {
              ctx.addIssue({
                code: import_zod.z.ZodIssueCode.invalid_type,
                expected: "number",
                received: typeof val
              });
            }
          });
        } else {
          let zodNumberProp = import_zod.z.number({
            required_error: `${prop.title} is required`
          });
          if (prop.minimum != null) {
            zodNumberProp = zodNumberProp.min(prop.minimum);
          }
          if (prop.maximum != null) {
            zodNumberProp = zodNumberProp.max(prop.maximum);
          }
          if (prop.multipleOf) {
            zodNumberProp = zodNumberProp.multipleOf(prop.multipleOf);
          }
          zodProp = import_zod.z.preprocess((val) => {
            if (val === "") {
              return void 0;
            }
            if (typeof val === "string") {
              return Number(val);
            }
            return val;
          }, zodNumberProp);
        }
        break;
      }
      case "string": {
        if (prop.format === "date-time") {
          zodProp = import_zod.z.preprocess((val) => {
            if (typeof val === "string") {
              return new Date(val);
            }
            return val;
          }, import_zod.z.date());
          break;
        }
        let zodStringProp = import_zod.z.string();
        if (prop.pattern) {
          zodStringProp = zodStringProp.regex(
            new RegExp(prop.pattern),
            "Invalid format"
          );
        }
        zodProp = zodStringProp;
        break;
      }
      case "boolean": {
        zodProp = import_zod.z.boolean();
        break;
      }
      case "object": {
        zodProp = createNestedZodSchema(prop.properties || {}, prop);
        if (prop.validationDependencies) {
          zodProp = zodProp.superRefine((data, ctx) => {
            validateDependencies(
              data,
              ctx,
              prop.validationDependencies,
              prop.properties
            );
          });
        }
        break;
      }
      case "array": {
        if (prop.items && !Array.isArray(prop.items) && typeof prop.items === "object") {
          const itemZodSchema = toZod(prop.items, "", prop);
          zodProp = import_zod.z.array(itemZodSchema);
        } else {
          throw new Error("Unsupported items array");
        }
        break;
      }
      default:
        throw new Error(`Unsupported type: ${prop.type}`);
    }
    if (parentSchema.required && !parentSchema.required.includes(fullKey)) {
      zodProp = zodProp.optional();
    }
    return zodProp;
  }
  const zodSchema = createNestedZodSchema(
    formFieldSchema.properties || {},
    formFieldSchema
  );
  let result = zodSchema;
  if (formFieldSchema.validationDependencies) {
    result = result.superRefine((data, ctx) => {
      validateDependencies(
        data,
        ctx,
        formFieldSchema.validationDependencies,
        formFieldSchema.properties
      );
    });
  }
  return result;
}
function validateDependencies(data, ctx, validationDependencies, properties) {
  if (!validationDependencies || !properties) {
    return;
  }
  for (const validationDependency of validationDependencies) {
    const targetFieldSchema = (0, import_get.default)(properties, validationDependency.targetField);
    const referenceFieldSchema = (0, import_get.default)(
      properties,
      validationDependency.referenceField
    );
    const targetFieldValue = (0, import_get.default)(data, validationDependency.targetField);
    const targetFieldTitle = targetFieldSchema == null ? void 0 : targetFieldSchema.title;
    const referenceFieldValue = (0, import_get.default)(data, validationDependency.referenceField);
    const referenceFieldTitle = referenceFieldSchema == null ? void 0 : referenceFieldSchema.title;
    if (targetFieldValue == null && referenceFieldValue == null) {
      continue;
    }
    let parsedTargetValue;
    let parsedReferenceValue;
    if ((targetFieldSchema == null ? void 0 : targetFieldSchema.type) === "string" && targetFieldSchema.format === "date-time") {
      if (typeof targetFieldValue === "string") {
        parsedTargetValue = new Date(targetFieldValue);
      } else if (targetFieldValue instanceof Date && !isNaN(targetFieldValue.getTime())) {
        parsedTargetValue = targetFieldValue;
      }
    } else if ((targetFieldSchema == null ? void 0 : targetFieldSchema.type) === "integer") {
      if (typeof targetFieldValue === "string" || typeof targetFieldValue === "number") {
        parsedTargetValue = BigInt(targetFieldValue);
      } else if (typeof targetFieldValue === "bigint") {
        parsedTargetValue = targetFieldValue;
      }
    } else if ((targetFieldSchema == null ? void 0 : targetFieldSchema.type) === "number") {
      if (typeof targetFieldValue === "number") {
        parsedTargetValue = targetFieldValue;
      }
    }
    if ((referenceFieldSchema == null ? void 0 : referenceFieldSchema.type) === "string" && referenceFieldSchema.format === "date-time") {
      if (typeof referenceFieldValue === "string") {
        parsedReferenceValue = new Date(referenceFieldValue);
      } else if (referenceFieldValue instanceof Date && !isNaN(referenceFieldValue.getTime())) {
        parsedReferenceValue = referenceFieldValue;
      }
    } else if ((referenceFieldSchema == null ? void 0 : referenceFieldSchema.type) === "integer") {
      if (typeof referenceFieldValue === "string" || typeof referenceFieldValue === "number") {
        parsedReferenceValue = BigInt(referenceFieldValue);
      } else if (typeof referenceFieldValue === "bigint") {
        parsedReferenceValue = referenceFieldValue;
      }
    } else if ((referenceFieldSchema == null ? void 0 : referenceFieldSchema.type) === "number") {
      if (typeof referenceFieldValue === "number") {
        parsedReferenceValue = referenceFieldValue;
      }
    }
    if (parsedTargetValue && parsedReferenceValue) {
      switch (validationDependency.condition) {
        case ValidationConditionEnum.GREATER_THAN:
          if (!(parsedTargetValue > parsedReferenceValue)) {
            ctx.addIssue({
              code: import_zod.z.ZodIssueCode.custom,
              message: `${targetFieldTitle} must be greater than ${referenceFieldTitle}`,
              path: validationDependency.targetField.split(".")
            });
          }
          break;
        case ValidationConditionEnum.LESS_THAN:
          if (!(parsedTargetValue < parsedReferenceValue)) {
            ctx.addIssue({
              code: import_zod.z.ZodIssueCode.custom,
              message: `${targetFieldTitle} must be less than ${referenceFieldTitle}`
            });
          }
          break;
        case ValidationConditionEnum.GREATER_THAN_OR_EQUAL:
          if (!(parsedTargetValue >= parsedReferenceValue)) {
            ctx.addIssue({
              code: import_zod.z.ZodIssueCode.custom,
              message: `${targetFieldTitle} must be greater than or equal to ${referenceFieldTitle}`
            });
          }
          break;
        case ValidationConditionEnum.LESS_THAN_OR_EQUAL:
          if (!(parsedTargetValue <= parsedReferenceValue)) {
            ctx.addIssue({
              code: import_zod.z.ZodIssueCode.custom,
              message: `${targetFieldTitle} must be less than or equal to ${referenceFieldTitle}`
            });
          }
          break;
        case ValidationConditionEnum.EQUAL:
          if (!(parsedTargetValue === parsedReferenceValue)) {
            ctx.addIssue({
              code: import_zod.z.ZodIssueCode.custom,
              message: `${targetFieldTitle} must be equal to ${referenceFieldTitle}`
            });
          }
          break;
      }
    }
  }
}

// src/utils/get-allowed-privileged-roles.ts
function getAllowedPrivilegedRoles(userIsStaff, userIsAllowlisted, userIsArtist) {
  const roles = [];
  if (userIsStaff) {
    roles.push("staff");
  }
  if (userIsAllowlisted) {
    roles.push("allowlisted");
  }
  if (userIsArtist) {
    roles.push("artist");
  }
  return roles;
}

// src/utils/submit-transaction.ts
var import_get2 = __toESM(require("lodash/get"));
function mapFormValuesToArgs(schemaArgs, formValues, projectIndex, coreContractAddress) {
  return schemaArgs.reduce((acc, arg) => {
    if (arg === "projectIndex") {
      return acc.concat(projectIndex);
    }
    if (arg === "coreContractAddress") {
      return acc.concat(coreContractAddress);
    }
    return acc.concat([(0, import_get2.default)(formValues, arg)]);
  }, []);
}
function submitTransaction(_0) {
  return __async(this, arguments, function* ({
    publicClient,
    walletClient,
    address,
    abi,
    functionName,
    args,
    onSimulationSuccess,
    onUserAccepted
  }) {
    if (!walletClient.account) {
      throw Error("No account selected");
    }
    try {
      const { request } = yield publicClient.simulateContract({
        address,
        abi,
        functionName,
        args,
        account: walletClient.account,
        chain: walletClient.chain
      });
      onSimulationSuccess == null ? void 0 : onSimulationSuccess();
      const hash = yield walletClient.writeContract(request);
      onUserAccepted == null ? void 0 : onUserAccepted();
      if (hash) {
        const { status, blockHash } = yield publicClient.waitForTransactionReceipt({
          hash
        });
        if (status !== "success") {
          throw new Error("Transaction reverted");
        }
        return { hash, blockHash };
      } else {
        throw new Error("Cannot retrieve transaction hash");
      }
    } catch (e) {
      if (e && typeof e === "object" && "shortMessage" in e && typeof e.shortMessage === "string") {
        throw new Error(e.shortMessage);
      }
      throw e;
    }
  });
}

// src/generated/graphql.ts
var ReceiptSettlementDataFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ReceiptSettlementData" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "receipt_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "project" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "featured_token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "media_url" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "project_minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "excess_settlement_funds" } }] } }] };
var ProjectDetailsFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ProjectDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "projects_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artist_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artist_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "complete" } }, { "kind": "Field", "name": { "kind": "Name", "value": "start_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "auction_start_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "auction_end_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "aspect_ratio" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "max_invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "paused" } }, { "kind": "Field", "name": { "kind": "Name", "value": "featured_token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "media_url" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "default_vertical" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "category" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "hosted" } }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "MinterConfigurationDetails" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "MinterDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "minters_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "description_template" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "MinterConfigurationDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "project_minter_configurations" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "currency_symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "base_price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "offchain_extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "MinterDetails" } }] } }] } }] };
var BidDetailsFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "BidDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "bids_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "slot_index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bid_value" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rank" } }, { "kind": "Field", "name": { "kind": "Name", "value": "time_of_bid" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bidder_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "is_removed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "log_index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tx_hash" } }] } }] };
var GetReceiptDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetReceipt" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "receipt_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "excess_settlement_funds" } }] } }] } }] };
var GetReceiptsWithExcessSettlementFundsForUserDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetReceiptsWithExcessSettlementFundsForUser" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddress" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "supportedMinterTypes" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "minter_type_names_enum" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "receipt_metadata" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "user_address" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddress" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "excess_settlement_funds" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_neq" }, "value": { "kind": "StringValue", "value": "0", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "minter" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "supportedMinterTypes" } } }] } }] } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "project_minter_configuration" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "complete" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "auction_end_time" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lt" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }] }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "ReceiptSettlementData" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ReceiptSettlementData" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "receipt_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "project" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "featured_token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "media_url" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "project_minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "excess_settlement_funds" } }] } }] };
var GetProjectDetailsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProjectDetails" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "projects_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "ProjectDetails" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "MinterDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "minters_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "description_template" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "MinterConfigurationDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "project_minter_configurations" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "currency_symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "base_price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "offchain_extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "MinterDetails" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ProjectDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "projects_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artist_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artist_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "complete" } }, { "kind": "Field", "name": { "kind": "Name", "value": "start_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "auction_start_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "auction_end_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "aspect_ratio" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "max_invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "paused" } }, { "kind": "Field", "name": { "kind": "Name", "value": "featured_token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "media_url" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "default_vertical" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "category" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "hosted" } }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "MinterConfigurationDetails" } }] } }] } }] };
var GetUserTokensInAllowlistDocumentDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getUserTokensInAllowlistDocument" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "allowedProjectIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddressAndVaults" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "tokens_metadata" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "project_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "allowedProjectIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "owner_address" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddressAndVaults" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "owner_address" } }] } }] } }] };
var GetTokenDetailsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetTokenDetails" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "tokenId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "tokens_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "tokenId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invocation" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invocation" } }, { "kind": "Field", "name": { "kind": "Name", "value": "live_view_url" } }, { "kind": "Field", "name": { "kind": "Name", "value": "project" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] } }] };
var GetUserBidsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetUserBids" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddress" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "project_ranked_bids" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "args" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "project" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "bidder_address" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "userAddress" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "rank" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "BidDetails" } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "BidDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "bids_metadata" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "slot_index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bid_value" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rank" } }, { "kind": "Field", "name": { "kind": "Name", "value": "time_of_bid" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bidder_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "is_removed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "log_index" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tx_hash" } }] } }] };
var GetProjectMinterConfigurationDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProjectMinterConfiguration" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "projects_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "project_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "user_is_artist" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "user_is_allowlisted" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_filter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "globally_allowed_minters" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "label" } }, { "kind": "Field", "name": { "kind": "Name", "value": "unversioned_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "version_number" } }] } }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "currency_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_symbol" } }, { "kind": "FragmentSpread", "name": { "kind": "Name", "value": "ProjectMinterConfigurationDetails" } }] } }] } }] } }, { "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "ProjectMinterConfigurationDetails" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "project_minter_configurations" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "project_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "base_price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currency_symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "max_invocations" } }, { "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "minter_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "project_configuration_schema" } }, { "kind": "Field", "name": { "kind": "Name", "value": "unversioned_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "version_number" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "extra_minter_details" } }] } }] } }] };
var GetProjectMinterConfigurationUpdatesDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProjectMinterConfigurationUpdates" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "projects_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "minter_configuration" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "properties_updated_at" } }] } }] } }] } }] };
var GetProjectsMetadataUpdatesQueryDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProjectsMetadataUpdatesQuery" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "projects_metadata_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "properties_updated_at" } }] } }] } }] };
var GetAllowlistUploadUrlDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetAllowlistUploadUrl" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "getAllowlistUploadUrl" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "projectId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "url" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }] } }] } }] };
var UpdateOffChainExtraMinterDetailsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateOffChainExtraMinterDetails" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "projectMinterConfigId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "extraMinterDetails" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_project_minter_configurations_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "projectMinterConfigId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_append" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "offchain_extra_minter_details" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "extraMinterDetails" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "offchain_extra_minter_details" } }] } }] } }] };

// src/generated/gql.ts
var documents = {
  "\n  query GetReceipt($id: String!) {\n    receipt_metadata_by_pk(id: $id) {\n      id\n      excess_settlement_funds\n    }\n  }\n": GetReceiptDocument,
  "\n  fragment ReceiptSettlementData on receipt_metadata {\n    id\n    project {\n      id\n      name\n      index\n      contract_address\n      featured_token {\n        media_url\n      }\n    }\n\n    minter {\n      address\n      minter_type\n    }\n\n    project_minter_configuration {\n      extra_minter_details\n    }\n    excess_settlement_funds\n  }\n": ReceiptSettlementDataFragmentDoc,
  '\n    query GetReceiptsWithExcessSettlementFundsForUser(\n      $userAddress: String!\n      $supportedMinterTypes: [minter_type_names_enum!]!\n    ) {\n      receipt_metadata(\n        where: {\n          user_address: { _eq: $userAddress }\n          excess_settlement_funds: { _neq: "0" }\n          minter: { type: { type: { _in: $supportedMinterTypes } } }\n          project_minter_configuration: {\n            _or: [\n              { complete: { _eq: true } }\n              { auction_end_time: { _lt: "now()" } }\n            ]\n          }\n        }\n      ) {\n        ...ReceiptSettlementData\n      }\n    }\n  ': GetReceiptsWithExcessSettlementFundsForUserDocument,
  "\n  fragment ProjectDetails on projects_metadata {\n    id\n    artist_address\n    artist_name\n    complete\n    start_datetime\n    auction_start_time\n    auction_end_time\n    aspect_ratio\n    name\n    invocations\n    max_invocations\n    paused\n\n    featured_token {\n      media_url\n    }\n\n    contract {\n      address\n      contract_type\n\n      default_vertical {\n        category {\n          hosted\n        }\n      }\n    }\n\n    minter_configuration {\n      ...MinterConfigurationDetails\n    }\n  }\n\n  fragment MinterConfigurationDetails on project_minter_configurations {\n    currency_symbol\n    currency_address\n    base_price\n\n    extra_minter_details\n    offchain_extra_minter_details\n\n    minter {\n      ...MinterDetails\n    }\n  }\n\n  fragment MinterDetails on minters_metadata {\n    address\n    minter_type\n    type {\n      description_template\n    }\n  }\n": ProjectDetailsFragmentDoc,
  "\n  query GetProjectDetails($projectId: String!) {\n    projects_metadata_by_pk(id: $projectId) {\n      ...ProjectDetails\n    }\n  }\n": GetProjectDetailsDocument,
  "\n  query getUserTokensInAllowlistDocument(\n    $allowedProjectIds: [String!]!\n    $userAddressAndVaults: [String!]!\n  ) {\n    tokens_metadata(\n      where: {\n        project_id: { _in: $allowedProjectIds }\n        owner_address: { _in: $userAddressAndVaults }\n      }\n    ) {\n      id\n      owner_address\n    }\n  }\n": GetUserTokensInAllowlistDocumentDocument,
  "\n  query GetTokenDetails($tokenId: String!) {\n    tokens_metadata_by_pk(id: $tokenId) {\n      id\n      token_id\n      invocation\n      contract_address\n      invocation\n      live_view_url\n      project {\n        name\n      }\n    }\n  }\n": GetTokenDetailsDocument,
  "\n  fragment BidDetails on bids_metadata {\n    id\n    slot_index\n    bid_value\n    rank\n    time_of_bid\n    bidder_address\n    is_removed\n    log_index\n    tx_hash\n  }\n": BidDetailsFragmentDoc,
  "\n  query GetUserBids($projectId: String!, $userAddress: String!) {\n    project_ranked_bids(\n      args: { project: $projectId }\n      where: { bidder_address: { _eq: $userAddress } }\n      order_by: { rank: asc }\n    ) {\n      ...BidDetails\n    }\n  }\n": GetUserBidsDocument,
  "\n    query GetProjectMinterConfiguration($projectId: String!) {\n      projects_metadata_by_pk(id: $projectId) {\n        project_id\n        user_is_artist\n\n        contract {\n          user_is_allowlisted\n          minter_filter {\n            type\n            address\n            globally_allowed_minters {\n              address\n              minter_type\n              type {\n                label\n                unversioned_type\n                version_number\n              }\n            }\n          }\n        }\n        minter_configuration {\n          currency_address\n          currency_symbol\n          ...ProjectMinterConfigurationDetails\n        }\n      }\n    }\n\n    fragment ProjectMinterConfigurationDetails on project_minter_configurations {\n      id\n      project_id\n      base_price\n      currency_address\n      currency_symbol\n      max_invocations\n      extra_minter_details\n      minter {\n        address\n        minter_type\n        type {\n          project_configuration_schema\n          unversioned_type\n          version_number\n        }\n        extra_minter_details\n      }\n    }\n  ": GetProjectMinterConfigurationDocument,
  "\n    query GetProjectMinterConfigurationUpdates($projectId: String!) {\n      projects_metadata_by_pk(id: $projectId) {\n        minter_configuration {\n          properties_updated_at\n        }\n      }\n    }\n  ": GetProjectMinterConfigurationUpdatesDocument,
  "\n  query GetProjectsMetadataUpdatesQuery($projectId: String!) {\n    projects_metadata_by_pk(id: $projectId) {\n      properties_updated_at\n    }\n  }\n": GetProjectsMetadataUpdatesQueryDocument,
  "\n  query GetAllowlistUploadUrl($projectId: String!) {\n    getAllowlistUploadUrl(projectId: $projectId) {\n      url\n      key\n    }\n  }\n": GetAllowlistUploadUrlDocument,
  "\n    mutation UpdateOffChainExtraMinterDetails(\n      $projectMinterConfigId: String!\n      $extraMinterDetails: jsonb!\n    ) {\n      update_project_minter_configurations_by_pk(\n        pk_columns: { id: $projectMinterConfigId }\n        _append: { offchain_extra_minter_details: $extraMinterDetails }\n      ) {\n        offchain_extra_minter_details\n      }\n    }\n  ": UpdateOffChainExtraMinterDetailsDocument
};
function graphql(source) {
  var _a;
  return (_a = documents[source]) != null ? _a : {};
}

// src/minter-configuration/graphql-operations.ts
var getProjectMinterConfigurationQueryDocument = graphql(
  /* GraphQL */
  `
    query GetProjectMinterConfiguration($projectId: String!) {
      projects_metadata_by_pk(id: $projectId) {
        project_id
        user_is_artist

        contract {
          user_is_allowlisted
          minter_filter {
            type
            address
            globally_allowed_minters {
              address
              minter_type
              type {
                label
                unversioned_type
                version_number
              }
            }
          }
        }
        minter_configuration {
          currency_address
          currency_symbol
          ...ProjectMinterConfigurationDetails
        }
      }
    }

    fragment ProjectMinterConfigurationDetails on project_minter_configurations {
      id
      project_id
      base_price
      currency_address
      currency_symbol
      max_invocations
      extra_minter_details
      minter {
        address
        minter_type
        type {
          project_configuration_schema
          unversioned_type
          version_number
        }
        extra_minter_details
      }
    }
  `
);
var getProjectMinterConfigurationUpdatesQueryDocument = graphql(
  /* GraphQL */
  `
    query GetProjectMinterConfigurationUpdates($projectId: String!) {
      projects_metadata_by_pk(id: $projectId) {
        minter_configuration {
          properties_updated_at
        }
      }
    }
  `
);
var getProjectsMetadataUpdatesQueryDocument = graphql(
  /* GraphQL */
  `
  query GetProjectsMetadataUpdatesQuery($projectId: String!) {
    projects_metadata_by_pk(id: $projectId) {
      properties_updated_at
    }
  }
`
);
var getAllowlistUploadUrlQueryDocument = graphql(
  /* GraphQL */
  `
  query GetAllowlistUploadUrl($projectId: String!) {
    getAllowlistUploadUrl(projectId: $projectId) {
      url
      key
    }
  }
`
);
var updateOffChainExtraMinterDetailsMutationDocument = graphql(
  /* GraphQL */
  `
    mutation UpdateOffChainExtraMinterDetails(
      $projectMinterConfigId: String!
      $extraMinterDetails: jsonb!
    ) {
      update_project_minter_configurations_by_pk(
        pk_columns: { id: $projectMinterConfigId }
        _append: { offchain_extra_minter_details: $extraMinterDetails }
      ) {
        offchain_extra_minter_details
      }
    }
  `
);

// src/minter-configuration/utils/generate-minter-selection-form-schema.ts
function generateMinterSelectionFormSchema(shared) {
  const args = ["projectIndex", "minter.address"];
  const inputs = [
    {
      internalType: "uint256",
      name: "_projectId",
      type: "uint256"
    },
    {
      internalType: "address",
      name: "_minter",
      type: "address"
    }
  ];
  if (shared) {
    args.splice(1, 0, "coreContractAddress");
    inputs.splice(1, 0, {
      internalType: "address",
      name: "_coreContract",
      type: "address"
    });
  }
  return {
    title: "Set Minter For Project",
    type: "object",
    compound: true,
    compoundBehavior: "transactionGroup",
    onChain: true,
    transactionDetails: {
      functionName: "setMinterForProject",
      args,
      abi: [
        {
          inputs,
          name: "setMinterForProject",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function"
        }
      ]
    },
    properties: {
      "minter.address": {
        type: "string",
        title: "Minter Address"
      }
    },
    required: ["minter.address"]
  };
}

// src/minter-configuration/utils/get-initial-minter-configuration-values-for-form-field.ts
var import_get3 = __toESM(require("lodash/get"));
var import_set = __toESM(require("lodash/set"));

// src/minter-configuration/display-processing/index.ts
var import_viem = require("viem");
function processValueForDisplay(args) {
  return __async(this, null, function* () {
    const { value, displayProcessing, minterConfiguration, publicClient } = args;
    const valueType = typeof value;
    switch (displayProcessing) {
      case "weiToEth": {
        if (value && valueType !== "string" && valueType !== "number" && valueType !== "bigint") {
          throw new Error(
            `Unexpected value type for weiToEth transformation. Expected string, number, or bigint, received ${valueType}`
          );
        }
        if (value === void 0 || value === null) {
          return "";
        }
        if ((minterConfiguration == null ? void 0 : minterConfiguration.currency_address) && minterConfiguration.currency_address !== import_viem.zeroAddress) {
          try {
            const decimals = yield publicClient.readContract({
              address: minterConfiguration.currency_address,
              abi: [
                {
                  inputs: [],
                  name: "decimals",
                  outputs: [
                    {
                      internalType: "uint8",
                      name: "",
                      type: "uint8"
                    }
                  ],
                  stateMutability: "view",
                  type: "function"
                }
              ],
              functionName: "decimals"
            });
            return Number(
              (0, import_viem.formatUnits)(BigInt(value), decimals)
            );
          } catch (e) {
            console.warn(
              "Failed to fetch currency decimals, falling back to 18",
              e
            );
          }
        }
        return Number((0, import_viem.formatEther)(BigInt(value)));
      }
      case "unixTimestampToDatetime": {
        if (value && valueType !== "number" && valueType !== "string") {
          throw new Error(
            `Unexpected value type for unixTimestampToDatetime transformation. Expected string or number, received ${valueType}`
          );
        }
        return value ? new Date(Number(value) * 1e3).toISOString() : (/* @__PURE__ */ new Date()).toISOString();
      }
      default:
        return value;
    }
  });
}

// src/minter-configuration/utils/get-initial-minter-configuration-values-for-form-field.ts
function getInitialMinterConfigurationValuesForFormField(formField, projectMinterConfiguration, publicClient) {
  return __async(this, null, function* () {
    const initialValues = {};
    function recursiveInitialValues(schema, configuration, parentKey = "") {
      return __async(this, null, function* () {
        var _a;
        if (schema.type === "object" && schema.properties) {
          for (const [key, propSchema] of Object.entries(schema.properties)) {
            if (!propSchema || typeof propSchema !== "object") {
              continue;
            }
            const fullKey = parentKey ? `${parentKey}.${key}` : key;
            yield recursiveInitialValues(propSchema, configuration, fullKey);
          }
        } else {
          const initialValue = (0, import_get3.default)(
            configuration,
            parentKey,
            (_a = schema.default) != null ? _a : null
          );
          const processedInitialValue = yield processValueForDisplay({
            value: initialValue,
            displayProcessing: schema.displayProcessing,
            minterConfiguration: configuration,
            publicClient
          });
          (0, import_set.default)(initialValues, parentKey, processedInitialValue);
        }
      });
    }
    yield recursiveInitialValues(formField, projectMinterConfiguration);
    return initialValues;
  });
}

// src/minter-configuration/submission-processing/index.ts
var import_get5 = __toESM(require("lodash/get"));
var import_set2 = __toESM(require("lodash/set"));
var import_merge = __toESM(require("lodash/merge"));

// src/utils/merkle.ts
var import_merkletreejs = __toESM(require("merkletreejs"));
var import_viem2 = require("viem");
function textOrCsvAddressListToArray(fileContent) {
  const addresses = fileContent.split(/[\r\n,]+/);
  const cleanedAddresses = addresses.map((address) => address.trim()).filter((address) => address !== "");
  return cleanedAddresses;
}
function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = (e) => {
      if (!e.target) return reject(new Error("Invalid file"));
      resolve(e.target.result);
    };
    fr.onerror = reject;
    fr.readAsText(new Blob([file]));
  });
}
var getMerkleRoot = (addresses) => {
  const merkleTree = new import_merkletreejs.default(
    addresses.map((addr) => hashAddress(addr)),
    import_viem2.keccak256,
    { sortPairs: true }
  );
  const root = merkleTree.getHexRoot();
  return root;
};
var hashAddress = (address) => {
  return Buffer.from(
    (0, import_viem2.keccak256)((0, import_viem2.encodePacked)(["address"], [address])).slice(2),
    "hex"
  );
};

// src/minter-configuration/submission-processing/process-allowlist-file-to-merkle-root.ts
function processAllowlistFileToMerkleRoot(value, args) {
  return __async(this, null, function* () {
    var _a, _b;
    const {
      clientContext,
      projectId,
      minterConfiguration,
      allowedPrivilegedRolesForProject
    } = args;
    if (!(value instanceof FileList && value.length > 0)) {
      throw new Error(
        "Unexpected form value for merkle root transformation. Please provide a text or csv file."
      );
    }
    const file = value[0];
    const fileType = value[0].type;
    if (!(fileType === "text/plain" || fileType === "text/csv")) {
      throw new Error(
        "Unexpected file type for merkle root transformation. Please provide a text or csv file."
      );
    }
    const allowlistFileText = yield readFileAsText(file);
    const allowlist = textOrCsvAddressListToArray(allowlistFileText);
    const getAllowlistUploadUrlRes = yield clientContext.graphqlClient.request(
      getAllowlistUploadUrlQueryDocument,
      {
        projectId
      }
    );
    if (!((_a = getAllowlistUploadUrlRes.getAllowlistUploadUrl) == null ? void 0 : _a.key) || !((_b = getAllowlistUploadUrlRes.getAllowlistUploadUrl) == null ? void 0 : _b.url)) {
      throw new Error("Unexpected response from server. Please try again.");
    }
    const { url } = getAllowlistUploadUrlRes.getAllowlistUploadUrl;
    try {
      const res = yield fetch(url, {
        method: "PUT",
        body: JSON.stringify(allowlist),
        headers: {
          "Content-Type": "application/json"
        }
      });
      if (!res.ok) {
        console.error(yield res.text());
        throw new Error("Unexpected error uploading allowlist file");
      }
    } catch (e) {
      console.error(e);
      throw new Error("Unexpected error uploading allowlist file");
    }
    const merkleRoot = getMerkleRoot(allowlist);
    yield clientContext.graphqlClient.request(
      updateOffChainExtraMinterDetailsMutationDocument,
      {
        projectMinterConfigId: minterConfiguration.id,
        extraMinterDetails: {
          pendingMerkleRoot: merkleRoot,
          pendingAllowlistedAddressesLink: url.split("?")[0]
        }
      },
      {
        "x-hasura-role": (() => {
          if (allowedPrivilegedRolesForProject.includes("staff")) {
            return "staff";
          } else if (allowedPrivilegedRolesForProject.includes("allowlisted")) {
            return "allowlisted";
          } else if (allowedPrivilegedRolesForProject.includes("artist")) {
            return "artist";
          } else {
            return "base_user";
          }
        })()
      }
    );
    return merkleRoot;
  });
}

// src/minter-configuration/submission-processing/process-project-contract-token-holder-list.ts
var import_difference = __toESM(require("lodash/difference"));
function processProjectContractTokenHolderList(value, args) {
  var _a;
  const { minterConfiguration } = args;
  if (!Array.isArray(value) || !value.every((val) => typeof val === "string")) {
    throw new Error("Unexpected form value for token holder allowlist.");
  }
  const currentlyAllowedProjectIds = (_a = minterConfiguration.extra_minter_details.allowlistedAddressAndProjectId) != null ? _a : [];
  const updatedAllowedProjectIds = value;
  const addedProjectIds = (0, import_difference.default)(
    updatedAllowedProjectIds,
    currentlyAllowedProjectIds
  );
  const removedProjectIds = (0, import_difference.default)(
    currentlyAllowedProjectIds,
    updatedAllowedProjectIds
  );
  const addArgs = addedProjectIds.reduce(
    (acc, id) => {
      const [contractAddress, projectIndex] = id.split("-");
      return {
        ownedNFTAddressesAdd: [...acc.ownedNFTAddressesAdd, contractAddress],
        ownedNFTProjectIdsAdd: [...acc.ownedNFTProjectIdsAdd, projectIndex]
      };
    },
    {
      ownedNFTAddressesAdd: [],
      ownedNFTProjectIdsAdd: []
    }
  );
  const removeArgs = removedProjectIds.reduce(
    (acc, id) => {
      const [contractAddress, projectIndex] = id.split("-");
      return {
        ownedNFTAddressesRemove: [
          ...acc.ownedNFTAddressesRemove,
          contractAddress
        ],
        ownedNFTProjectIdsRemove: [
          ...acc.ownedNFTProjectIdsRemove,
          projectIndex
        ]
      };
    },
    {
      ownedNFTAddressesRemove: [],
      ownedNFTProjectIdsRemove: []
    }
  );
  return __spreadValues(__spreadValues({}, removeArgs), addArgs);
}

// src/minter-configuration/submission-processing/process-auction-details-to-half-life-seconds.ts
var import_get4 = __toESM(require("lodash/get"));
function calculateHalfLifeSecondsFromAuctionDetails(startPriceInEther, endPriceInEther, startTime, endTime) {
  const priceRatio = startPriceInEther / endPriceInEther;
  const completedHalfLives = Math.floor(Math.log(priceRatio) / Math.log(2));
  const y1 = startPriceInEther / Math.pow(2, completedHalfLives);
  const y2 = y1 / 2;
  const z2 = (endPriceInEther - y1) / (y2 - y1);
  const halfLifeSeconds = Math.round(
    (endTime - startTime) / ((completedHalfLives + 1) * z2 + completedHalfLives * (1 - z2))
  );
  return halfLifeSeconds.toString();
}
function processAuctionDetailsToHalfLifeSeconds(args) {
  const { formValues } = args;
  const startTime = (0, import_get4.default)(formValues, "extra_minter_details.startTime");
  const endTime = (0, import_get4.default)(
    formValues,
    "extra_minter_details.approximateDAExpEndTime"
  );
  const startPrice = (0, import_get4.default)(
    formValues,
    "extra_minter_details.startPrice"
  );
  const basePrice = (0, import_get4.default)(formValues, "base_price");
  if (typeof startTime !== "string" && !(startTime instanceof Date) || typeof endTime !== "string" && !(endTime instanceof Date) || typeof startPrice !== "number" && typeof startPrice !== "string" || typeof basePrice !== "number" && typeof basePrice !== "string") {
    throw new Error("Unexpected form value for auction details.");
  }
  const startTimeUnixTimestamp = Math.floor(
    new Date(startTime).getTime() / 1e3
  );
  const endTimeUnixTimestamp = Math.floor(new Date(endTime).getTime() / 1e3);
  return calculateHalfLifeSecondsFromAuctionDetails(
    Number(startPrice),
    Number(basePrice),
    startTimeUnixTimestamp,
    endTimeUnixTimestamp
  );
}

// src/minter-configuration/submission-processing/process-eth-to-wei.ts
var import_viem3 = require("viem");
function processEthToWei(value, args) {
  return __async(this, null, function* () {
    const { minterConfiguration, clientContext } = args;
    const { publicClient } = clientContext;
    if (typeof value !== "string" && typeof value !== "number" && typeof value !== "bigint") {
      throw new Error(
        "Value must be a string, number, or bigint to convert to wei"
      );
    }
    const valueString = value.toString();
    if (minterConfiguration.currency_address !== import_viem3.zeroAddress) {
      try {
        const decimals = yield publicClient.readContract({
          address: minterConfiguration.currency_address,
          abi: [
            {
              inputs: [],
              name: "decimals",
              outputs: [
                {
                  internalType: "uint8",
                  name: "",
                  type: "uint8"
                }
              ],
              stateMutability: "view",
              type: "function"
            }
          ],
          functionName: "decimals"
        });
        return (0, import_viem3.parseUnits)(valueString, decimals);
      } catch (e) {
        console.warn("Failed to fetch currency decimals, falling back to 18", e);
      }
    }
    return (0, import_viem3.parseUnits)(valueString, 18);
  });
}

// src/minter-configuration/submission-processing/index.ts
function processProjectMinterConfigurationFormValuesForSubmission(args) {
  return __async(this, null, function* () {
    var _a;
    const { formValues, schema } = args;
    let transformedFormValues = {};
    for (const [fieldName, fieldSchema] of Object.entries(
      (_a = schema.properties) != null ? _a : {}
    )) {
      const formFieldValue = (0, import_get5.default)(formValues, fieldName);
      if (typeof fieldSchema === "object" && fieldSchema.submissionProcessing) {
        switch (fieldSchema.submissionProcessing) {
          case "merkleRoot": {
            const merkleRoot = yield processAllowlistFileToMerkleRoot(
              formFieldValue,
              args
            );
            (0, import_set2.default)(transformedFormValues, fieldName, merkleRoot);
            break;
          }
          case "tokenHolderAllowlist": {
            const allowRemoveArgs = processProjectContractTokenHolderList(
              formFieldValue,
              args
            );
            transformedFormValues = (0, import_merge.default)(transformedFormValues, allowRemoveArgs);
            break;
          }
          case "ethToWei": {
            const weiValue = yield processEthToWei(formFieldValue, args);
            (0, import_set2.default)(transformedFormValues, fieldName, weiValue);
            break;
          }
          case "datetimeToUnixTimestamp": {
            const unixTimestamp = Math.floor(
              new Date(formFieldValue).getTime() / 1e3
            );
            (0, import_set2.default)(transformedFormValues, fieldName, unixTimestamp);
            break;
          }
          case "auctionEndDatetimeToHalfLifeSeconds": {
            const halfLifeSeconds = processAuctionDetailsToHalfLifeSeconds(args);
            (0, import_set2.default)(transformedFormValues, fieldName, halfLifeSeconds);
            break;
          }
        }
      } else {
        (0, import_set2.default)(transformedFormValues, fieldName, formFieldValue);
      }
    }
    return removeDuplicateDotNotationKeys(__spreadValues(__spreadValues({}, formValues), transformedFormValues));
  });
}
function hasNestedObjectForDotNotation(obj, dotNotationKey) {
  const parts = dotNotationKey.split(".");
  let current = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    if (current[parts[i]] === void 0) {
      return false;
    }
    current = current[parts[i]];
  }
  return typeof current === "object" && !Array.isArray(current);
}
function removeDuplicateDotNotationKeys(obj) {
  const newObj = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (!key.includes(".")) {
      newObj[key] = value;
    }
  });
  Object.keys(obj).forEach((key) => {
    if (key.includes(".") && !hasNestedObjectForDotNotation(newObj, key)) {
      const parts = key.split(".");
      let current = newObj;
      for (let i = 0; i < parts.length; i++) {
        if (i === parts.length - 1) {
          current[parts[i]] = obj[key];
        } else {
          current[parts[i]] = current[parts[i]] || {};
          current = current[parts[i]];
        }
      }
    }
  });
  return newObj;
}

// src/utils/async-poll.ts
function asyncPoll(fn, pollInterval = 5e3, pollTimeout = 3e4) {
  return __async(this, null, function* () {
    const endTime = (/* @__PURE__ */ new Date()).getTime() + pollTimeout;
    const checkCondition = (resolve, reject) => {
      Promise.resolve(fn()).then((result) => {
        const currentTime = (/* @__PURE__ */ new Date()).getTime();
        if (result.done) {
          resolve(result.data);
        } else if (currentTime < endTime) {
          setTimeout(checkCondition, pollInterval, resolve, reject);
        } else {
          reject(new Error("Timeout reached in async poller"));
        }
      }).catch((err) => {
        reject(err);
      });
    };
    return new Promise(checkCondition);
  });
}

// src/minter-configuration/utils/polling.ts
function pollForSyncedMinterConfigUpdates(clientContext, projectId, transactionConfirmedAt, updateProperties) {
  return __async(this, null, function* () {
    yield asyncPoll(
      () => __async(this, null, function* () {
        try {
          const result = yield clientContext.graphqlClient.request(
            getProjectMinterConfigurationUpdatesQueryDocument,
            {
              projectId
            }
          );
          const project = result.projects_metadata_by_pk;
          if (!project) {
            return Promise.reject(
              new Error(`Could not find project with id ${projectId}`)
            );
          }
          const transactionConfirmedAtTimestamp = transactionConfirmedAt.getTime();
          const hasUpdatedProperty = updateProperties.some((property) => {
            var _a, _b, _c;
            const propertyUpdatedAt = new Date(
              (_c = (_b = (_a = project.minter_configuration) == null ? void 0 : _a.properties_updated_at) == null ? void 0 : _b[property]) != null ? _c : 0
            );
            const propertyUpdatedAtTimestamp = propertyUpdatedAt.getTime();
            return propertyUpdatedAtTimestamp > transactionConfirmedAtTimestamp;
          });
          if (hasUpdatedProperty) {
            return Promise.resolve({
              done: true,
              data: project
            });
          } else {
            return Promise.resolve({
              done: false
            });
          }
        } catch (err) {
          return Promise.reject(err);
        }
      }),
      500,
      // interval
      9e4
      // timeout
    );
  });
}
function pollForProjectUpdates(clientContext, projectId, transactionConfirmedAt, updateProperties) {
  return __async(this, null, function* () {
    yield asyncPoll(
      () => __async(this, null, function* () {
        try {
          const result = yield clientContext.graphqlClient.request(
            getProjectsMetadataUpdatesQueryDocument,
            {
              projectId
            }
          );
          const project = result.projects_metadata_by_pk;
          if (!project) {
            return Promise.reject(
              new Error(`Could not find project with id ${projectId}`)
            );
          }
          const transactionConfirmedAtTimestamp = transactionConfirmedAt.getTime();
          const hasUpdatedProperty = updateProperties.some((property) => {
            var _a, _b;
            const propertyUpdatedAt = new Date(
              (_b = (_a = project.properties_updated_at) == null ? void 0 : _a[property]) != null ? _b : 0
            );
            const propertyUpdatedAtTimestamp = propertyUpdatedAt.getTime();
            return propertyUpdatedAtTimestamp > transactionConfirmedAtTimestamp;
          });
          if (hasUpdatedProperty) {
            return Promise.resolve({
              done: true,
              data: project
            });
          } else {
            return Promise.resolve({
              done: false
            });
          }
        } catch (err) {
          return Promise.reject(err);
        }
      }),
      500,
      // interval
      9e4
      // timeout
    );
  });
}

// src/minter-configuration/index.ts
function generateProjectMinterConfigurationForms(args) {
  return __async(this, null, function* () {
    var _a, _b, _c, _d;
    const { projectId, clientContext } = args;
    const [coreContractAddress, projectIndexString] = projectId.split("-");
    const projectIndex = Number(projectIndexString);
    const res = yield clientContext.graphqlClient.request(
      getProjectMinterConfigurationQueryDocument,
      {
        projectId
      }
    );
    const project = res.projects_metadata_by_pk;
    if (!project) {
      throw new Error(`Could not find project with id ${projectId}`);
    }
    if (!project.contract.minter_filter) {
      throw new Error(
        `Project with id ${projectId} is not on a contract with an associated minter filter`
      );
    }
    const allowedPrivilegedRolesForProject = getAllowedPrivilegedRoles(
      clientContext.userIsStaff,
      (_a = project.contract.user_is_allowlisted) != null ? _a : false,
      (_b = project.user_is_artist) != null ? _b : false
    );
    const context = __spreadProps(__spreadValues({}, args), {
      allowedPrivilegedRolesForProject,
      coreContractAddress,
      projectIndex,
      project
    });
    const minterSelectionForm = yield generateSelectMinterForm(context);
    let configurationForms = [minterSelectionForm];
    const minterConfiguration = (_c = res.projects_metadata_by_pk) == null ? void 0 : _c.minter_configuration;
    if (!minterConfiguration || !minterConfiguration.minter) {
      return { data: project, forms: configurationForms };
    }
    const minterConfigurationSchema = (_d = minterConfiguration.minter.type) == null ? void 0 : _d.project_configuration_schema;
    if (!minterConfigurationSchema || Object.keys(minterConfigurationSchema).length === 0) {
      console.warn("No minter configuration schema found for project", projectId);
      return { data: project, forms: configurationForms };
    }
    const configForms = yield Promise.all(
      Object.entries(minterConfigurationSchema.properties).map(
        (_0) => __async(this, [_0], function* ([key, value]) {
          return generateMinterForm(__spreadProps(__spreadValues({}, context), {
            key,
            formSchema: value,
            minterConfiguration
          }));
        })
      )
    );
    configurationForms = configurationForms.concat(configForms);
    return { data: project, forms: configurationForms };
  });
}
function generateSelectMinterForm(_0) {
  return __async(this, arguments, function* ({
    clientContext,
    project,
    projectId,
    projectIndex,
    coreContractAddress,
    onConfigurationChange
  }) {
    var _a, _b;
    const minterConfiguration = project.minter_configuration;
    const minterSelectionFormSchema = generateMinterSelectionFormSchema(
      project.contract.minter_filter.type === "MinterFilterV2" /* MinterFilterV2 */
    );
    const minterSelectionFormSchemaWithMinters = minterSelectionFormSchema;
    if ((_a = minterSelectionFormSchemaWithMinters.properties) == null ? void 0 : _a["minter.address"]) {
      const globallyAllowedMinters = (_b = project.contract.minter_filter.globally_allowed_minters) != null ? _b : [];
      const latestMinters = globallyAllowedMinters.reduce(
        (dedupedMinters, minter) => {
          return dedupedMinters.filter((mntr) => {
            var _a2, _b2, _c, _d, _e;
            return ((_a2 = minterConfiguration == null ? void 0 : minterConfiguration.minter) == null ? void 0 : _a2.address) === mntr.address || ((_b2 = mntr.type) == null ? void 0 : _b2.unversioned_type) !== ((_c = minter.type) == null ? void 0 : _c.unversioned_type) || (((_d = mntr.type) == null ? void 0 : _d.version_number) || 0) >= (((_e = minter.type) == null ? void 0 : _e.version_number) || 0);
          });
        },
        globallyAllowedMinters
      );
      minterSelectionFormSchemaWithMinters.properties["minter.address"].oneOf = latestMinters.map((minter) => {
        var _a2, _b2;
        return {
          const: minter.address,
          title: `${(_b2 = (_a2 = minter.type) == null ? void 0 : _a2.label) != null ? _b2 : ""} - ${minter.address}`
        };
      }).sort((a, b) => b.title.localeCompare(a.title));
    }
    const form = {
      key: "setMinterForProject",
      formSchema: minterSelectionFormSchemaWithMinters,
      initialFormValues: yield getInitialMinterConfigurationValuesForFormField(
        minterSelectionFormSchemaWithMinters,
        minterConfiguration != null ? minterConfiguration : null,
        clientContext.publicClient
      ),
      zodSchema: formFieldSchemaToZod(minterSelectionFormSchemaWithMinters),
      handleSubmit: (formValues, onProgress) => __async(this, null, function* () {
        const walletClient = clientContext.walletClient;
        if (!walletClient) {
          throw new Error(
            "A walletClient is required to submit the set minter form"
          );
        }
        if (!project || !project.contract.minter_filter || !(0, import_get6.default)(formValues, "minter.address") || !walletClient.account) {
          console.warn("handleSubmit called without required data");
          return;
        }
        onProgress == null ? void 0 : onProgress(SubmissionStatusEnum.SIMULATING_TRANSACTION);
        const minterFilterAddress = project.contract.minter_filter.address;
        const functionArgs = mapFormValuesToArgs(
          minterSelectionFormSchemaWithMinters.transactionDetails.args,
          formValues,
          projectIndex,
          coreContractAddress
        );
        const { blockHash } = yield submitTransaction({
          publicClient: clientContext.publicClient,
          walletClient,
          address: minterFilterAddress,
          abi: minterSelectionFormSchemaWithMinters.transactionDetails.abi,
          functionName: minterSelectionFormSchemaWithMinters.transactionDetails.functionName,
          args: functionArgs,
          onSimulationSuccess: () => onProgress == null ? void 0 : onProgress(SubmissionStatusEnum.AWAITING_USER_SIGNATURE),
          onUserAccepted: () => {
            onProgress == null ? void 0 : onProgress(SubmissionStatusEnum.CONFIRMING);
          }
        });
        onProgress == null ? void 0 : onProgress(SubmissionStatusEnum.SYNCING);
        const { timestamp } = yield clientContext.publicClient.getBlock({
          blockHash
        });
        const transactionConfirmedAt = new Date(Number(timestamp) * 1e3);
        yield pollForProjectUpdates(
          clientContext,
          projectId,
          transactionConfirmedAt,
          ["minter_configuration_id"]
        );
        const updatedForms = yield generateProjectMinterConfigurationForms({
          clientContext,
          onConfigurationChange,
          projectId
        });
        onConfigurationChange(updatedForms);
      })
    };
    return form;
  });
}
function generateMinterForm(args) {
  return __async(this, null, function* () {
    const {
      clientContext,
      key,
      projectId,
      formSchema,
      projectIndex,
      coreContractAddress,
      minterConfiguration,
      onConfigurationChange
    } = args;
    const processedFormSchema = processFormSchema(formSchema);
    const initialFormValues = yield getInitialMinterConfigurationValuesForFormField(
      processedFormSchema,
      minterConfiguration,
      clientContext.publicClient
    );
    return {
      key,
      formSchema: processedFormSchema,
      initialFormValues,
      zodSchema: formFieldSchemaToZod(processedFormSchema),
      handleSubmit: (formValues, onProgress) => __async(this, null, function* () {
        var _a;
        const walletClient = clientContext.walletClient;
        if (!walletClient) {
          throw new Error(
            "A walletClient is required to submit the minter configuration form"
          );
        }
        if (!minterConfiguration.minter || !isOnChainFormFieldSchema(processedFormSchema) || !processedFormSchema.transactionDetails || !walletClient.account) {
          throw new Error("Invalid form configuration");
        }
        const transactionDetails = processedFormSchema.transactionDetails;
        onProgress == null ? void 0 : onProgress(SubmissionStatusEnum.SIMULATING_TRANSACTION);
        const transformedFormValues = yield processProjectMinterConfigurationFormValuesForSubmission(__spreadProps(__spreadValues({}, args), {
          formValues,
          schema: formSchema
        }));
        const functionArgs = mapFormValuesToArgs(
          transactionDetails.args,
          transformedFormValues,
          projectIndex,
          coreContractAddress
        );
        const { blockHash } = yield submitTransaction({
          publicClient: clientContext.publicClient,
          walletClient,
          address: minterConfiguration.minter.address,
          abi: transactionDetails.abi,
          functionName: transactionDetails.functionName,
          args: functionArgs,
          // sdk needs to come from values,
          onSimulationSuccess: () => onProgress == null ? void 0 : onProgress(SubmissionStatusEnum.AWAITING_USER_SIGNATURE),
          onUserAccepted: () => onProgress == null ? void 0 : onProgress(SubmissionStatusEnum.CONFIRMING)
        });
        onProgress == null ? void 0 : onProgress(SubmissionStatusEnum.SYNCING);
        const { timestamp } = yield clientContext.publicClient.getBlock({
          blockHash
        });
        const transactionConfirmedAt = new Date(Number(timestamp) * 1e3);
        const expectedUpdates = (_a = transactionDetails.syncCheckFieldsOverride) != null ? _a : transactionDetails.args;
        yield pollForSyncedMinterConfigUpdates(
          clientContext,
          projectId,
          transactionConfirmedAt,
          expectedUpdates
        );
        onConfigurationChange(
          yield generateProjectMinterConfigurationForms(args)
        );
      })
    };
  });
}

// src/index.ts
var import_graphql_request = require("graphql-request");
var ArtBlocksClient = class {
  constructor({
    publicClient,
    walletClient,
    authToken,
    graphqlEndpoint
  }) {
    var _a;
    const graphqlClient = new import_graphql_request.GraphQLClient(graphqlEndpoint, {
      headers: () => {
        if (!authToken) {
          return {};
        }
        return {
          Authorization: `Bearer ${authToken}`
        };
      }
    });
    const jwtString = Buffer.from(
      (_a = authToken == null ? void 0 : authToken.split(".")[1]) != null ? _a : "",
      "base64"
    ).toString();
    const jwtData = jwtString ? JSON.parse(jwtString) : null;
    const userIsStaff = Boolean(jwtData == null ? void 0 : jwtData.isStaff);
    this.context = {
      graphqlClient,
      publicClient,
      walletClient,
      userIsStaff
    };
  }
  setAuthToken(authToken) {
    if (!authToken) {
      this.context.graphqlClient.setHeaders({});
      return;
    }
    this.context.graphqlClient.setHeaders({
      Authorization: `Bearer ${authToken}`
    });
  }
  getPublicClient() {
    return this.context.publicClient;
  }
  setPublicClient(publicClient) {
    this.context.publicClient = publicClient;
  }
  setWalletClient(walletClient) {
    this.context.walletClient = walletClient;
  }
  getWalletClient() {
    return this.context.walletClient;
  }
  graphqlRequest(document, ...variablesAndRequestHeaders) {
    return __async(this, null, function* () {
      return this.context.graphqlClient.request(
        document,
        ...variablesAndRequestHeaders
      );
    });
  }
  getProjectMinterConfigurationContext(projectId) {
    return __async(this, null, function* () {
      if (!this.context.publicClient) {
        throw new Error(
          "A publicClient is required to get project minter configuration context"
        );
      }
      let subscribers = [];
      const notifySubscribers = (updatedConfig) => {
        for (const subscriber of subscribers) {
          subscriber(updatedConfig);
        }
      };
      const { forms, data } = yield generateProjectMinterConfigurationForms({
        projectId,
        onConfigurationChange: notifySubscribers,
        clientContext: this.context
      });
      return {
        data,
        // Provide a method to access the current configuration
        forms,
        // Provide a method to refresh the configuration
        refresh: () => __async(this, null, function* () {
          if (!this.context.publicClient) {
            throw new Error(
              "A publicClient is required to get project minter configuration context"
            );
          }
          yield generateProjectMinterConfigurationForms({
            projectId,
            onConfigurationChange: notifySubscribers,
            clientContext: this.context
          });
        }),
        // Provide a method to subscribe to changes in the configuration
        subscribe: (callback) => {
          subscribers.push(callback);
          return () => {
            subscribers = subscribers.filter(
              (subscriber) => subscriber !== callback
            );
          };
        }
      };
    });
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ArtBlocksClient,
  SubmissionStatusEnum
});
